module.exports = __webpack_public_path__ + "img/gps-not-accurate.c2f4448d.png";